
export const APP_VERSION = '1.0.2';
export const APP_VERSION_DEV = '1.0.2';
export const BUILD_DATE = '28-08-2025 15:29:29';
export const BUILD_NUMBER = '280820251529';
